'use client';

import React from 'react';
import { useSearchParams } from 'next/navigation';
import ProductDetailClient from './ProductDetailClient';

/**
 * Forces ProductDetailClient to fully remount whenever the `slug` query
 * param changes. App Router treats /product-detail?slug=a → ?slug=b as a
 * soft navigation that keeps the same component instance mounted, which
 * means useState values (selectedImage, selectedSize, quantity, added-
 * to-cart toast, etc.) persist from the previous product. That's why the
 * image thumbnail stayed identical when clicking different featured cards —
 * stale state carried over.
 *
 * Key on slug: React unmounts the old tree, mounts a fresh one, Apollo
 * reissues the useQuery against the new variables on mount. Mirrors the
 * clean per-product page isolation that beauty-store gets via Pages Router's
 * getStaticPaths + getStaticProps model.
 */
export default function ProductDetailKeyed() {
  const searchParams = useSearchParams();
  const slug = searchParams?.get('slug') || '';
  return <ProductDetailClient key={slug || 'no-slug'} />;
}
